<div class="dashboard-container">
    <h2 class="dashboard-heading">Promotion Dashboard</h2>
    <div class="flex justify-content-between flex-wrap filter">
        <div class="flex align-items-center justify-content-center">
            <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-search" />
                <input type="text" pInputText [(ngModel)]="searchText" placeholder="Search" />
            </p-iconField>
        </div>

        <div class="flex align-items-center justify-content-center">
            <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" [showIcon]="true"
                [showButtonBar]="true" [iconDisplay]="'input'" placeholder="Select dates" />
        </div>
    </div>

    <div class=" card">
        <p-tabView (onChange)="onTabChange($event)">
            <p-tabPanel [header]="'Submitted(' + submittedCount + ')'">
                <app-promotion-dashboard-tabs #submittedTab [status]="1"
                    (openAction)="openActionModal($event.promo, $event.isApprove)" (previewFile)="openPreview($event)"
                    [searchQuery]="searchText" [dateRange]="rangeDates"></app-promotion-dashboard-tabs>

            </p-tabPanel>
            <p-tabPanel [header]="'Approved (' + approvedCount + ')'">
                <app-promotion-dashboard-tabs #ApprovedTab [status]="2"
                    (openAction)="openActionModal($event.promo, $event.isApprove)" (previewFile)="openPreview($event)"
                    [searchQuery]="searchText" [dateRange]="rangeDates"></app-promotion-dashboard-tabs>
            </p-tabPanel>
            <p-tabPanel [header]="'Rejected (' + rejectedCount + ')'">
                <app-promotion-dashboard-tabs #rejectedTab [status]="3"
                    (openAction)="openActionModal($event.promo, $event.isApprove)" (previewFile)="openPreview($event)"
                    [searchQuery]="searchText" [dateRange]="rangeDates"></app-promotion-dashboard-tabs>
            </p-tabPanel>
        </p-tabView>
    </div>

</div>

<!-- File Preview Modal -->
<p-dialog header="File Preview" [(visible)]="previewVisible" [modal]="true" [style]="{ width: '70vw' }"
    [closable]="true">
    <ng-container *ngIf="isPdf(previewFile?.fileName); else imageBlock">
        <ngx-extended-pdf-viewer [src]="previewFile?.filePath" useBrowserLocale="true"
            height="600px"></ngx-extended-pdf-viewer>
    </ng-container>
    <ng-template #imageBlock>
        <img [src]="previewFile?.filePath" alt="Attachment" class="full-image-preview" />
    </ng-template>
</p-dialog>

<!-- Action Modal -->
<p-dialog header="{{ isApproveAction ? 'Approve Promotion' : 'Reject Promotion' }}" [(visible)]="actionModalVisible"
    [modal]="true" [style]="{ width: '600px' }" [closable]="true">

    <div class="p-field mb-2">
        <textarea id="reason" pInputTextarea [(ngModel)]="actionReason" (ngModelChange)="onReasonChange($event)"
            rows="4" autoResize
            [placeholder]="isApproveAction ? 'Write the reason for approval' : 'Write the reason for rejection'">
</textarea>
    </div>

    <div class="p-dialog-footer flex justify-content-end flex-wrap p-0 mt-5">
        <button pButton label="Cancel" class="btn-cancel mr-2" (click)="actionModalVisible = false"></button>
        <button pButton [label]="isApproveAction ? 'Approve' : 'Reject'"
            [class]="isApproveAction ? 'btn-primary btn' : 'danger1 btn'" (click)="submitAction()">
        </button>

    </div>
</p-dialog>